import React from "react";

import { LoadingShimmer } from "@newsela/angelou";
import PropTypes from "prop-types";

import { loadingShimmerContainerCss } from "./LoadingShimmerMapper.style";

const propTypes = {
  loading: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

/**
 * Each child of this component is replaced by a LoadingShimmer if the loading parameter is true.
 * Otherwise, it returns children as is.
 * @param {object} props
 * @returns {React.ReactNode} react node
 */
const LoadingShimmerMapper = ({ loading, children }) => {
  if (loading)
    return React.Children.map(children, () => (
      <div style={loadingShimmerContainerCss}>
        <LoadingShimmer />
      </div>
    ));
  return children;
};

LoadingShimmerMapper.propTypes = propTypes;

export default LoadingShimmerMapper;
